import React from 'react'
import {Route} from "react-router-dom";
import ProtectedRoute from "../auth/ProtectedRoute";
import ListOrders from '../admin/ListOrders';
import ProcessOrder from '../admin/ProcessOrder';
import ListUsers from '../admin/ListUser';
import UserDetail from '../admin/UserDetail';
import UpdateUser from '../admin/UpdateUser';
import ListDrivers from '../admin/driver/ListDrivers';
import EditDriverDetail from '../admin/driver/EditDriverDetail';
import UserLocation from '../admin/UserLocation';
import ListPendingDrivers from '../admin/driver/ListPendingDrivers';
import ListSuspendedDrivers from '../admin/driver/ListSuspendedDrivers';
import ListRejectedDrivers from '../admin/driver/ListRejectedDrivers';
import DriverPayments from '../admin/driver/DriverPayments';

const adminRoutes = () => {
  return (
    <>

     <Route 
       path="/admin/drivers" 
       element={
       <ProtectedRoute admin={true}>
       <ListDrivers />
       </ProtectedRoute>
        }/>  

       <Route 
       path="/admin/users/location/:id" 
       element={
       <ProtectedRoute admin={true}>
       <UserLocation />
       </ProtectedRoute>
        }/>  

      <Route 
       path="/admin/driver/update/:id" 
       element={
       <ProtectedRoute admin={true}>
       <EditDriverDetail />
       </ProtectedRoute>
        }/>  

      <Route 
       path="/admin/driver/payment/:id" 
       element={
       <ProtectedRoute admin={true}>
       <DriverPayments />
       </ProtectedRoute>
        }/>  


     <Route 
       path="/admin/UpdateUser/:id" 
       element={
       <ProtectedRoute admin={true}>
       <UpdateUser />
       </ProtectedRoute>
        }/>  
  

        <Route
        path="/admin/bookings"
        element={
          <ProtectedRoute admin={true}>
            <ListOrders />
          </ProtectedRoute>
        }
      />

        <Route
        path="/admin/orders/:id"
        element={
          <ProtectedRoute admin={true}>
            <ProcessOrder />
          </ProtectedRoute>
        }
      />

       <Route
        path="/admin/users"
        element={
          <ProtectedRoute admin={true}>
            <ListUsers />
          </ProtectedRoute>
        }
      /> 

        <Route
        path="/admin/users/:id"
        element={
          <ProtectedRoute admin={true}>
            <UserDetail />
          </ProtectedRoute>
        }
      /> 

      
      <Route 
       path="/admin/pending-drivers" 
       element={
       <ProtectedRoute admin={true}>
       <ListPendingDrivers />
       </ProtectedRoute>
        }/>  

      <Route 
       path="/admin/suspended-drivers" 
       element={
       <ProtectedRoute admin={true}>
       <ListSuspendedDrivers />
       </ProtectedRoute>
        }/>   

<Route 
       path="/admin/rejected-drivers" 
       element={
       <ProtectedRoute admin={true}>
       <ListRejectedDrivers />
       </ProtectedRoute>
        }/>  

    </>
  )
}

export default adminRoutes
